import { Dispatch } from 'redux'

import api from 'common/api'

import { SuggestionReason, SuggestionReasonTypes } from '.'
import { selectSuggestionReasonsRequested } from './selectors'

interface SuggestionReasonsResponse {
  reasons: SuggestionReason[]
  maxLength: number
}

const fetchSuggestionReasons = () => (dispatch: Dispatch<any>, getState: () => any) => {
  if (selectSuggestionReasonsRequested(getState())) return Promise.resolve()

  dispatch({ type: SuggestionReasonTypes.REQUEST_SUGGESTION_REASONS })

  return api
    .get<SuggestionReasonsResponse>('/api/suggestion_reasons')
    .then((response) => {
      dispatch(updateSuggestionReasons(response.reasons || [], response.maxLength))
    })
    .catch(() => {
      dispatch({ type: SuggestionReasonTypes.FAIL_SUGGESTION_REASONS })
    })
}

const updateSuggestionReasons = (reasons: SuggestionReason[], maxLength?: number) => {
  return {
    type: SuggestionReasonTypes.UPDATE_SUGGESTION_REASONS,
    payload: maxLength ? { reasons, maxLength } : { reasons },
  }
}

const actions = {
  updateSuggestionReasons,
  fetchSuggestionReasons,
}

export default actions
